import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import camelCase from 'lodash/camelCase'

import {
    sendHoverSoundCommand,
    sendClickSoundCommand,
} from 'react-wot-bootstrap'

import { PRODUCT_ITEMS_RECEIVED } from '../../translations'
import { isCnRealm } from 'containers/WGCWXShop/helpers'

import { PRODUCT_TYPES } from 'containers/WGCWXShop/constants'

import styles from './WGCWXShopCard.scss'

class WGCWXShopProductCard extends React.Component {
    static propTypes = {
        title: PropTypes.node.isRequired,
        description: PropTypes.node,
        price: PropTypes.node,
        boughtAmount: PropTypes.number.isRequired,
        availableAmount: PropTypes.number.isRequired,
        productType: PropTypes.string.isRequired,
        groupName: PropTypes.node,
        value: PropTypes.number,
        size: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
        main: PropTypes.bool,
        isAvailable: PropTypes.bool,
        hideCount: PropTypes.bool,
        realm: PropTypes.string.isRequired,

        onClick: PropTypes.func.isRequired,
    }

    state = {
        isHover: false,
    }

    handleMouseEnter = () => {
        sendHoverSoundCommand()
        this.setState({
            isHover: true,
        })
    }

    handleMouseLeave = () => {
        this.setState({
            isHover: false,
        })
    }

    handleMouseDown = () => {
        sendClickSoundCommand()
    }

    render() {
        const cardClassNames = classNames(
            styles.card,
            styles[`card__${this.props.size}`],
            this.state.isHover && styles.card__hover,
            this.props.isAvailable && styles.card__green_corner,
            this.props.main && styles.card__main,
        )

        const imageClassNames = classNames(
            styles.image,
            styles[`image__${this.props.productType}`],
            isCnRealm(this.props.realm) && styles.isCnRealm,
            this.props.productType === PRODUCT_TYPES.PREMIUM_PLUS &&
                styles[`image__${this.props.productType}_${this.props.value}`],
        )

        return (
            <div
                className={cardClassNames}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                onMouseDown={this.handleMouseDown}
                onClick={this.props.onClick}
                id={this.props.productType}
            >
                <div className={styles.placeholder}>
                    <div className={imageClassNames} />
                </div>
                <div className={styles.inner}>
                    {
                        !this.props.hideCount &&
                        <div className={styles.items_count}>
                            {this.state.isHover && (
                                <span className={styles.items_count_description}>
                                    {PRODUCT_ITEMS_RECEIVED}
                                </span>
                            )}
                            {` ${this.props.boughtAmount} / ${this.props.availableAmount}`}
                        </div>
                    }
                    <div className={styles.content}>
                        <h5 className={classNames(styles.title, styles[`title__${camelCase(this.props.productType)}`])}>
                            {this.props.title}
                            {this.props.groupName}
                        </h5>
                        {this.props.size === 'large' && (
                            <div className={styles.description}>
                                {this.props.description}
                            </div>
                        )}
                    </div>
                    <footer className={styles.price}>
                        {this.props.price}
                    </footer>
                </div>
            </div>
        )
    }
}

export default WGCWXShopProductCard



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/WGCWXShopProductCard.jsx